import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]
  static values = { url: String }

  connect() {
    this.timeout = null
  }

  search() {
    clearTimeout(this.timeout)
    const query = this.inputTarget.value.trim()

    if (query.length < 2) {
      this.resultsTarget.innerHTML = ""
      this.resultsTarget.classList.add("hidden")
      return
    }

    this.timeout = setTimeout(() => {
      this.fetchResults(query)
    }, 200)
  }

  async fetchResults(query) {
    const url = `${this.urlValue}?q=${encodeURIComponent(query)}`
    const response = await fetch(url, {
      headers: {
        "Turbo-Frame": "search_results",
        "Accept": "text/html"
      }
    })
    const html = await response.text()
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, "text/html")
    const frame = doc.querySelector("turbo-frame#search_results")
    if (frame) {
      this.resultsTarget.innerHTML = frame.innerHTML
      this.resultsTarget.classList.remove("hidden")
    }
  }

  go() {
    const firstLink = this.resultsTarget.querySelector("a")
    if (firstLink) {
      firstLink.click()
    } else {
      const query = this.inputTarget.value.trim()
      if (query.length >= 2) {
        window.location.href = `${this.urlValue}?q=${encodeURIComponent(query)}`
      }
    }
  }
}
